<!--
 * @Author: Latte
 * @Date: 2021-09-09 16:04:27
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-26 09:25:12
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\FileManagement\File\fileList.vue
-->
<template>
  <div class="app-container">
    <el-tabs v-model="activeName" v-if="showConditionTab" @tab-click="handleClick()" style="margin-top: -40px">
      <el-tab-pane label="全部"  name="-1"></el-tab-pane>
      <el-tab-pane
              v-for="item of options"
              :label="item.showName"
              :name="item.fieldValue"
      >
      </el-tab-pane>
    </el-tabs>
    <el-card class="filter-container" shadow="never">
      <div>
        <el-form
                :model="listQuery"
                size="small"
                :inline="true"
        >
          <el-row>
            <el-col :span="19">
                <el-input
                        style="margin-left: 5px"
                        v-model="listQuery.keyword"
                        placeholder="输入关键词搜索资料，支持：文件名 / 描述 / 作者名称"
                        clearable
                        @keyup.native.enter="change"
                ><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
            </el-col>
            <el-col :span="5">
              <el-button
                      @click="change"
                      type="primary"
                      size="small"
                      style="margin-left: 10px;border-radius: 2px;"
              >搜索</el-button>
              <el-button
                      type="primary"
                      style="margin-left: 10px;margin-top:2px;border-radius: 2px"
                      size="small"
                      title="Add File"
                      @click="openAddFileDialog()"
              >上传新资料
              </el-button>
            </el-col>
          </el-row>
          <el-select clearable style="margin-left: 6px;margin-top: 10px;width:168px" :placeholder="item.showName" v-for="(item,index) in conditionOptions" v-model="arr[index]" @change="((val)=>{change(val,index)})">
            <el-option v-for="item in conditionOptions[index].childConditionList"
                :key="item.fieldValue"
                :label="conditionOptions[index].fieldName === 'csFileTypeID' ? getFileTypeDespWithCondition(item) : item.showName"
                :value="item"
            >
            </el-option>
          </el-select>
        </el-form>
      </div>
    </el-card>
    <div style="margin-bottom:10px;float: right">
      <el-select
              style="width: 120px"
              v-model="listQuery.type"
              placeholder="请选择文件类型"
              @change="handleFileType()"
      >
        <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="main">
      <!-- 表格 -->
      <el-table
        v-loading="loading"
        :data="fileList"
        :header-cell-style="{ background: '#F5F7FA' }"
        style="width: 100%; margin-bottom: 20px"
        stripe
        border
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form
              label-position="left"
              inline
              class="demo-table-expand"
              v-if="scope.row.csFileParams"
            >
              <el-row>
                <el-col :span="8">
                  <el-form-item label="文档访问限制">
                    <span>{{scope.row.accessLimit===0?"无访问限制":scope.row.accessLimit===1?"过期不能访问":"未知"}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="所属分类">
                    <span>{{
                      showDataType(scope.row.csFileParams.dataType)
                    }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="应用领域">
                    <span>{{
                      showSpecificValueByFieldName(scope.row.csFileParams.dataType,"areaType",scope.row.csFileParams.areaType)
                    }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="控制面板">
                    <span>{{
                      showSpecificValueByFieldName(scope.row.csFileParams.dataType,"controlPanel",scope.row.csFileParams.controlPanel)
                    }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="部件">
                    <span>{{
                   showSpecificValueByFieldName(scope.row.csFileParams.dataType,"parts",scope.row.csFileParams.parts)
                    }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="功率值">
                    <span>{{   showSpecificValueByFieldName(scope.row.csFileParams.dataType,"power",scope.row.csFileParams.power) }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="限束器">
                    <span>{{showSpecificValueByFieldName(scope.row.csFileParams.dataType,"speedGovernor",scope.row.csFileParams.speedGovernor) }}
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="资料描述">
                    <span>{{scope.row.fileDesc}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <el-form
                    label-position="left"
                    inline
                    class="demo-table-expand"
                    v-else="scope.row.fileDesc"
            >
              <el-col :span="8">
                <el-form-item label="资料描述">
                  <span>{{scope.row.fileDesc}}</span>
                </el-form-item>
              </el-col>
            </el-form>
            <span v-else>暂无数据</span>
          </template>
        </el-table-column>
        <el-table-column prop="csFileID" label="ID" align="center" width="60">
        </el-table-column>
        <el-table-column
          prop="fileShowName"
          label="文件名"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="资料类型"
          align="center"
          width="110"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{scope.row.typeList.length>0?scope.row.typeList[0].typeName:"-"}}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" width="95">
          <template slot-scope="scope">
            {{ scope.row.createTime | ellipsis }}
          </template>
        </el-table-column>
        <el-table-column label="上传者" align="center" show-overflow-tooltip width="75">
          <template slot-scope="scope">
            <a style="color: blue">{{ scope.row.nickname}}</a>
          </template>
        </el-table-column>
        <el-table-column label="格式" align="center" width="60">
          <template slot-scope="scope">
            <a style="color: forestgreen">{{ scope.row.fileSuffix === ".pdf" ? "文档" :scope.row.fileSuffix === ".mp4" ? "视频":scope.row.fileSuffix === ".mp3"?"音频":scope.row.fileSuffix === ".jpg"?"图片":scope.row.fileSuffix === ".png"?"图片":"" }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="FileSize" label="大小(MB)" align="center" width="65">
          <template slot-scope="scope">
            {{ (scope.row.fileSize / 1024).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="浏览次数" align="center" width="60">
          <template slot-scope="scope">
            <a style="color: blue">{{ scope.row.viewTimes}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="downloadTimes" label="下载次数" align="center" width="60">
        </el-table-column>
        <el-table-column label="适用仪器" align="center" width="90">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              title="View series"
              icon="el-icon-tickets"
              style="width:60px"
              :disabled="!scope.row.seriesList.length"
              @click.stop="viewFileSeries(scope.row)"
            >
              {{ scope.row.seriesList.length }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="是否置顶"  align="center" width="80">
          <template slot-scope="scope"><el-switch v-model="scope.row.topStatus" active-color="#03be56" :active-value="1" :inactive-value="0"  @change="onTopStatusChange(scope.row.csFileID,$event)"></el-switch></template>
        </el-table-column>
        <el-table-column
          prop="operation"
          label="操作"
          align="center"
          width="250"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              title="View file"
              icon="el-icon-view"
              @click.stop="viewFile(scope.row)"
            >
            </el-button>
            <el-button
              type="info"
              size="small"
              title="Download file"
              icon="el-icon-download"
              @click.stop="downloadFile(scope.row)"
            >
            </el-button>
            <el-button
              type="primary"
              size="small"
              title="Edit file"
              icon="el-icon-edit"
              @click.stop="openEditFileDialog(scope.row)"
            >
            </el-button>
            <el-button
              :type="scope.row.isDeleted ? 'warning' : 'danger'"
              size="small"
              :title="scope.row.isDeleted ? 'Restore file' : 'Delete file'"
              :icon="
                scope.row.isDeleted ? 'el-icon-refresh-left' : 'el-icon-delete'
              "
              @click="deleteFile(scope.row)"
            >
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div v-show="totalCount > pageSize" class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="totalCount"
          :current-page="currentPage"
          @current-change="currentChange"
        />
      </div>
      <div style="margin-left: 10px">
        <p style="color: dimgrey;float: left" >共{{totalCount}}条</p>
        <el-select v-model="pageSize" placeholder="全部产品分类" style="width:110px;margin-left: 5px;margin-top:7px" @change="onPageSizeChange">
          <el-option v-for="item in pageSizeOptions" :value="item.fieldValue" :label="item.showName"
                     :key="item.fieldValue" />
        </el-select>
      </div>

    </div>

    <!-- 对话框：文档适用机型设备 -->
    <el-dialog title="仪器" :visible.sync="seriesListDialog" width="60%">
      <el-table :data="seriesList" max-height="450px" style="width: 100%">
        <el-table-column
          prop="number"
          label="编号"
          align="center"
        ></el-table-column>
        <el-table-column prop="seriesName" label="仪器系列名" align="center">
        </el-table-column>
        <el-table-column prop="model" label="仪器型号" align="center">
        </el-table-column>
        <el-table-column prop="version" label="仪器版本号" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>


    <!--对话框：浏览PDF文件-->
    <el-dialog
            :visible="showPdf === true"
            :append-to-body='true'
            :modal-append-to-body='true'
            :lock-scroll='true'
            :destroy-on-close='true'
            :close-on-click-modal='false'
            :width="'80%'"
            :before-close="closePreviewClick"
            top="200px"
            center>
      <div v-if="showPdf === true" class="dialog-body-content-base-style"
           style="justify-content: center; align-items: center">
        <embed :src="this.fileUrl" style="width: 100%; height: 700px"/>
      </div>
    </el-dialog>
    <!--对话框：浏览 视频/图片/音频/文档-->
    <el-dialog
            :visible="showDoc === true   || showImg === true || showVideo === true || showMp3 === true"
            :show-close="true"
            :width="'70%'"
            style="margin-top: 10px;"
            class="dialog-div-pre-style"
            :before-close="closePreviewClick"
            center>
      <div v-if="showDoc === true" class="dialog-body-content-base-style" style="justify-content: center; align-items: center">
        <iframe frameborder="0"
                :src="'https://view.officeapps.live.com/op/view.aspx?src=' + this.fileUrl"
                width='100%'>
        </iframe>
      </div>
      <div align="center" v-else-if="showImg === true">
        <img :src="this.fileUrl" @load="onLoadImg" :height="boxHeight" :width="boxWidth"/>
      </div>
      <div v-else-if="showVideo === true" align="center" class="dialog-body-content-base-style" style="justify-content: center; align-items: center">
        <video :src="this.fileUrl" controls autoplay class="video" width="100%"></video>
      </div>
      <div v-else-if="showMp3 === true" align="center" class="dialog-body-content-base-style">
        <audio :src="this.fileUrl" autoplay="autoplay" controls="controls" ref="audio" style="width: 70%"></audio>
      </div>
      <div align="center" style="margin-top: 10px;font-weight: bold">{{this.filePlayName}}</div>
    </el-dialog>

    <!-- 视频 -->
    <el-dialog title="视频" :visible.sync="videoDialog" width="30%">
      <video
        :src="videoSrc"
        controls
        controlslist="nodownload"
        style="max-width: 100%; max-height: 600px"
      ></video>
    </el-dialog>

    <!-- 对话框：添加上传文件 -->
    <el-dialog title="添加文件" :visible.sync="addFileDialog" :before-close="handleAddFileDialogClose" width="60%">
      <el-form v-loading="uploadLoading" :model="addFileForm">
        <el-divider content-position="center" style="margin-top: -30px">基本信息</el-divider>
        <el-form-item :label-width="labelWidth" label="文件名称" required>
          <el-autocomplete
                  v-model="addFileForm.showName"
                  :fetch-suggestions="querySearchAsync"
                  placeholder="请输入内容"
                  show-word-limit
                  :maxlength="100"
                  clearable
                  style="width:90%"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item :label-width="labelWidth" label="文件描述" >
          <el-input v-model="addFileForm.desc"
                    style="width:90%"
                    :maxlength="300"
                    type="textarea"
                    :autosize="{ minRows: 3}"
                    show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item :label-width="labelWidth" label="上传文件" required>
          <el-upload
            ref="upload"
            :http-request="getOSSUploadInfo"
            action=""
            accept=".jpg,.png,.mp3,.mp4,.PDF"
            :limit="1"
            :on-exceed="handleExceed"
            :on-change="onChange"
            :on-remove="onRemove"
            :file-list="uploadFileList"
            :before-upload="beforeUpload"
            :auto-upload="false"
          >
            <el-button slot="trigger" size="small" type="primary">
              选择文件
            </el-button>
            <div slot="tip" class="el-upload__tip">
              提示：一次最多允许上传一个；支持JPG/PNG/Mp3/PDF/MP4格式文件；大小不超过2GB。
            </div>
          </el-upload>
        </el-form-item>
        <el-row >
          <el-col :span="8">
            <el-form-item label="文件类型" :label-width="labelWidth" required>
              <el-select v-model="addFileForm.type" clearable placeholder="请选择" @change="onTypeChange($event)">
                <el-option
                        v-for="option in typeOptions"
                        :key="option.value"
                        :value="option.value"
                        :label="option.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
              <el-form-item label="文档访问限制" :label-width="labelWidth" required>
                <el-select
                        v-model="addFileForm.accessLimit"
                        placeholder="请选择"
                        clearable
                        :disabled="showExpireTimeInput"
                        @change="selectChange"
                >
                  <el-option
                          v-for="(item,index) in expireTimeOptions"
                          :key="index"
                          :label="item.label"
                          :value="item.value" />
                </el-select>
              </el-form-item>
          </el-col>
          <el-col :span="8" v-if="showWaterMarkStatus()">
            <el-form-item label="是否添加水印" :label-width="labelWidth" required>
              <el-switch active-text="是" inactive-text="否" v-model="addFileForm.waterMarkStatus" :active-value="0" :inactive-value="1"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-if="showSpecificProp">
          <el-divider content-position="center">详细参数</el-divider>
          <el-row >
            <el-col :span="8">
              <el-form-item label="所属分类" :label-width="labelWidth" required>
                <el-select v-model="csFileParam.dataType"
                           placeholder="请选择"
                           clearable
                           @change="onDataTypeChange($event)"
                >
                  <el-option
                      v-for="item of options"
                      :key="item.fieldValue"
                      :value="item.fieldValue"
                      :label="item.showName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="资料类型" :label-width="labelWidth" required>
                <el-select
                    no-data-text="无数据，请先选择'所属分类'"
                    v-model="addFileForm.fileCategory[0]"
                    clearable
                    @change="getAccessMark"
                >
                  <el-option
                      v-for="item in fileCategoryOptions"
                      :label="getFileTypeDespWithCondition({'fieldValue':item.value,'showName':item.label})"
                      :value="item.value"
                      :key="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="nameAreaType" :label-width="labelWidth" v-show="isShowAreaType" >
                <el-select v-model="csFileParam.areaType" clearable placeholder="请选择">
                  <el-option
                    v-for="option in areaTypeOptions"
                    :key="option.value"
                    :value="option.value"
                    :label="option.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="nameControlPanel" :label-width="labelWidth" v-show="isShowControlPanel" >
                <el-select
                  v-model="csFileParam.controlPanel"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="option in controlPanelOptions"
                    :key="option.value"
                    :value="option.value"
                    :label="option.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="nameParts" :label-width="labelWidth" v-show="isShowParts" >
                <el-select v-model="csFileParam.parts" clearable placeholder="请选择">
                  <el-option
                    v-for="option in partOptions"
                    :key="option.value"
                    :value="option.value"
                    :label="option.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="namePower" :label-width="labelWidth" v-show="isShowPower" >
                <el-select v-model="csFileParam.power" clearable placeholder="请选择">
                  <el-option
                    v-for="option in powerOptions"
                    :key="option.value"
                    :value="option.value"
                    :label="option.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="nameSpeedGovernor" :label-width="labelWidth" v-show="isShowSpeedGovernor" >
                <el-select
                  v-model="csFileParam.speedGovernor"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="option in speedGovernorOptions"
                    :key="option.value"
                    :value="option.value"
                    :label="option.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="nameMachineSeries" :label-width="labelWidth" v-show="isShowMachineSeries">
                <el-select v-model="addFileForm.seriesValue"  multiple collapse-tags filterable remote reserve-keyword
                           placeholder="搜索关键词或列表多选" :remote-method="(queryString)=>
                             {remoteMethod(queryString, seriesData);}">
                  <el-checkbox
                          v-model="check"
                          :indeterminate="addFileForm.seriesValue.length !== seriesData.length"
                          @change="selectAll"
                  >
                        全选
                  </el-checkbox>
                  <el-option v-for="item in seriesData"
                             :key="item.key"
                             :label="item.label"
                             :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="权限" :label-width="labelWidth"><div>{{accessMark}}</div></el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>

      <div slot="footer">
        <el-button
          size="small"
          :disabled="uploadLoading"
          @click="cancelUpload()"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          size="small"
          :disabled="uploadLoading"
          @click="submitUpload()"
        >
          确认
        </el-button>
        <el-progress
                v-show="showProgress"
                style="margin-top: 10px"
                :text-inside="true"
                :stroke-width="13"
                :percentage="progress"
        ></el-progress>
      </div>
    </el-dialog>

    <!-- 对话框：编辑文件 -->
    <el-dialog title="编辑文件" :visible.sync="editFileDialog" :before-close="handleEditFileDialogClose" width="60%">
      <el-form v-loading="uploadLoading" :model="addFileForm">
          <el-divider content-position="center" style="margin-top: -30px">基本信息</el-divider>
          <el-form-item label="文件名称"  :label-width="labelWidth" required>
            <el-autocomplete
                    v-model="addFileForm.showName"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="请输入内容"
                    show-word-limit
                    :maxlength="100"
                    clearable
                    style="width:90%"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="文件描述" :label-width="labelWidth">
            <el-input
                    type="textarea"
                    placeholder="请输入内容"
                    v-model="addFileForm.desc"
                    :maxlength="300"
                    :autosize="{ minRows: 4}"
                    style="width:90%"
                    show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="上传文件" :label-width="labelWidth" required>
            <el-upload
                    ref="upload"
                    :http-request="getOSSUploadInfo"
                    action=""
                    accept=".jpg,.png,.mp3,.mp4,.PDF"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :on-change="onChange"
                    :on-remove="onRemove"
                    :file-list="uploadFileList"
                    :before-upload="beforeUpload"
                    :auto-upload="false"
            >
              <el-button slot="trigger" size="small" type="primary">
                选择文件
              </el-button>
              <div slot="tip" class="el-upload__tip">
                提示：重新上传会覆盖掉原资料文件。支持上传JPG/PNG/Mp3/PDF/MP4格式文件，一次最多上传一个，大小不能超过2GB。
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="文件访问限制" :label-width="labelWidth" required>
            <el-row type="flex">
              <el-col>
                <el-select
                    v-model="addFileForm.accessLimit"
                    placeholder="请选择"
                    clearable
                    :disabled="showExpireTimeInput"
                    @change="selectChange"
                >
                  <el-option
                      v-for="(item,index) in expireTimeOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value" />
                </el-select>
              </el-col>
              <el-col v-if="showWaterMarkStatus()">
                <el-form-item label="是否添加水印" :label-width="labelWidth" required>
                  <el-switch active-text="是" inactive-text="否" v-model="addFileForm.waterMarkStatus" :active-value="0" :inactive-value="1"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        <div v-if="showSpecificProp">
          <el-divider content-position="center">详细参数</el-divider>
          <el-row>
            <el-col :span="8">
              <el-form-item label="资料类型" :label-width="labelWidth" required>
                <el-select
                        clearable
                        v-model="addFileForm.fileCategory[0]"
                        @change="getAccessMark">
                  <el-option
                    v-for="item in fileCategoryOptions"
                    :label="getFileTypeDespWithCondition({'fieldValue':item.value,'showName':item.label})"
                    :value="item.value"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属分类" :label-width="labelWidth" required>
                <el-select
                  v-model="csFileParam.dataType"
                  clearable
                  placeholder="请选择"
                  @change="onDataTypeChange($event)"
                >
                  <el-option
                    v-for="option in options"
                    :key="option.fieldValue"
                    :value="option.fieldValue"
                    :label="option.showName"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item :label="nameAreaType" :label-width="labelWidth" v-show="isShowAreaType">
                <el-select
                  clearable
                  v-model="csFileParam.areaType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="option in areaTypeOptions"
                    :key="option.value"
                    :value="option.value"
                    :label="option.label"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item :label="nameControlPanel" :label-width="labelWidth" v-show="isShowControlPanel">
                <el-select
                  clearable
                  v-model="csFileParam.controlPanel"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="option in controlPanelOptions"
                    :key="option.value"
                    :value="option.value"
                    :label="option.label"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item :label="nameParts" :label-width="labelWidth" v-show="isShowParts">
                <el-select
                  clearable
                  v-model="csFileParam.parts"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="option in partOptions"
                    :key="option.value"
                    :value="option.value"
                    :label="option.label"
                  ></el-option>
                </el-select
                        > </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item :label="namePower" :label-width="labelWidth" v-show="isShowPower">
                <el-select
                  clearable
                  v-model="csFileParam.power"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="option in powerOptions"
                    :key="option.value"
                    :value="option.value"
                    :label="option.label"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item :label="nameSpeedGovernor" :label-width="labelWidth" v-show="isShowSpeedGovernor" >
                <el-select
                  clearable
                  v-model="csFileParam.speedGovernor"
                  placeholder="请选择">
                    <el-option
                      v-for="option in speedGovernorOptions"
                      :key="option.value"
                      :value="option.value"
                      :label="option.label">
                    </el-option>
                </el-select
                        >
              </el-form-item>
            </el-col>
            <el-col :span="8">
            <el-form-item :label="nameMachineSeries" :label-width="labelWidth" v-show="isShowMachineSeries">
              <el-select v-model="addFileForm.seriesValue"
                         multiple filterable
                         collapse-tags
                         remote
                         reserve-keyword
                         placeholder="搜索关键词或列表多选" :remote-method="(queryString)=>
                           {remoteMethod(queryString, seriesData);}">
                <el-checkbox
                        v-model="check"
                        :indeterminate="addFileForm.seriesValue.length !== seriesData.length"
                        @change="selectAll"
                >
                  全选
                </el-checkbox>
                <el-option v-for="item in seriesData"
                           :key="item.key"
                           :label="item.label"
                           :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="权限" :label-width="labelWidth">{{accessMark}}</el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="cancelUpdate()">
          取消
        </el-button>
        <el-button type="primary" size="small" @click="editFile()">
          确认
        </el-button>
        <el-progress
                v-show="showProgress"
                style="margin-top: 10px"
                :text-inside="true"
                :stroke-width="13"
                :percentage="progress"
        ></el-progress>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import {isVaild} from "@/utils/validate";

var FileSaver = require("file-saver");
import {
  getFileList,
  getFileByCondition,
  getSeriesList,
  getOSSUploadInfo,
  addFile,
  editFile,
  deleteFile,
  getFileCategoryList,
  getAllCSDocumentList,
  getConditionList,
  topStatusFile,
  getMachineSeriesList,
} from "@/api/system/CSDocument/file";

export default {
  props:{
    initFileSearchValue:{
      type:String
    }
  },
  data() {
    return {
      sum:0,//共有几条记录
      showProgress: false,//进度条的显示
      progress: 0, //进度条数据
      permitUploadFile:false,//允许上传文件按钮
      boxWidth: "",
      boxHeight:"",
      arr:[],
      showConditionTab:true,
      activeName: "-1",
      roleList: [], //系统角色列表
      showExpireTimeInput:false,
      showCategory:true,
      showSpecificProp:true,
      showSelect:true,
      showCategorySelect:false,
      labelWidth:"120px",
      /*****以下是展示属性的标志******/
      isShowAreaType:      false,
      isShowControlPanel:  false,
      isShowPower:         false,
      isShowSpeedGovernor: false,
      isShowParts:         false,
      isShowMachineSeries: true,
      nameAreaType:"应用领域",
      nameControlPanel:"控制面板",
      namePower:"功率(KW)",
      nameSpeedGovernor:"限束器",
      nameParts:"设备部件",
      nameMachineSeries:"适用机型",
      /*****以上是展示属性的标志*******/

      /*******以下是预览文件配置参数*******/
      //文件路径
      pageCount: undefined, // pdf文件总页数
      filePlayName:"",      //文件完整名称

      //浏览文件配置参数
      showMp3:   false,
      showImg:   false,
      showDoc:   false,
      showPdf:   false,
      showVideo: false,
      fileUrl:    "",
      currentPagePdf: 0,    // pdf文件页码
      /*******以上是预览文件配置参数*******/
      loading: false,       // 加载开关
      uploadLoading: false, // 上传加载开关
      isSearched: false,    // 页面是否处于搜索状态
      totalCount: 0,        // 总数
      currentPage: 1,       // 当前页码
      pageSize: 10,         // 每页条数
      searchValue: "",      // 搜索内容
      fileList: [],         // 文件列表
      seriesListDialog: false, // 系列列表对话框开关
      seriesList: [],       // 系列列表
      videoDialog: false,   // 视频对话框开关
      videoSrc: "", // 视频路径
      uploadFileList: [],   // 上传文件列表
      addFileDialog: false, // 添加文件对话框开关
      type: '',
      /**************以下是新增文档配置参数*****************/
      // 添加文件表单
      addFileForm: {
        submitType:0,
        accessLimit:'',
        type:null,             // 0 产品资料 1 学习资源
        avatar: "",
        url: "",            // 文件URL
        userDataType: 0,    // 医用/射线
        fileName:"",        // 文件名称
        desc: "",           // 资源描述
        showName:"",        // 资源名称
        seriesValue: [],    // 适用机型
        fileCategory: [],   // 资料类型
        size: 0,
        suffix: "",
        waterMarkStatus:1
      },
      // 文件详细类型
      csFileParam: {
        areaType:      null,      // 作用领域
        controlPanel:  null,      // 控制面板
        dataType:      null,      // 分类
        parts:         null,      // 部件
        power:         null,      // 功率值
        speedGovernor: null,      // 限速器
      },
      /*****************以上是新增文档配置参数*******************/
      editFileDialog: false, // 编辑文件对话框开关
      editFileForm: {
        csFileParam: {},
      }, // 编辑文件表单
      editSeriesData: [],
      editFileCategoryData: [],
      ossInfo: "",          // OSS信息
      ossPath: "",          // OSS路径
      seriesData: [],       // 设备系列列表
      fileCategoryData: [], // 文件类别列表
      percentage: 0,        // 进度条数字
      nameSearchFinalList:[],      //名称搜索列表
      listQuery: {          // 检索内容
        type:0,
        keyword: "",        // 搜索框内容
        category: {},       // 分类
        condition: {},      // 筛选条件
        conditionVal: {},   // 筛选条件的值
      },
      conditionOptions: [], // 二级栏目数据
      conditionValOptions: [],// 三级栏目数据
      options: [],          // 顶部栏筛选选项（分类）
      fileCategoryOptions:[],
      areaTypeOptions: [],      // 作用领域（定制）
      controlPanelOptions: [],  // 控制面板（定制）
      partOptions: [],          // 部件（定制）
      powerOptions: [],         // 功率值（定制）
      speedGovernorOptions: [], // 限速器（定制）
      accessMark:"",             // 新增文档时的文档权限说明

      typeOptions: Object.freeze([
        {value:0,label:"产品资料"},
        {value:1,label:"学习资源"},
      ]),                        // 文件类型
      dataTypeOptions: Object.freeze([
        { value: 0, label: "超声" },
        { value: 1, label: "X-Ray" },
        { value: 2, label: "IBUS" },
      ]),                       // 文件所属范畴(弃用)
      expireTimeOptions: [
       {
          value: 0,
          label: '无访问限制'
        }, {
          value: 1,
          label: '过期不能访问'
        }
      ],
      pageSizeOptions:[{fieldValue:10,showName:"10条/页"},{fieldValue:20,showName:"20条/页"},{fieldValue:50,showName:"50条/页"}],
    };
  },
  created() {
    this.listQuery.keyword = this.initFileSearchValue
    // this.getFileList();           //获取文件列表
    this.getConditionList();      //获取分类+筛选条件
    this.getCSDocumentList();     //获取文档名称列表
    this.getFileCategoryList();   //获取资料类型列表个
    this.getSeriesList(null);         //获取适用机型列表
    this.handleSearchList()
  },

  computed: {
    check: {
      get () {
        if (this.addFileForm.seriesValue.length === this.seriesData.length) {
          return true
        }
        return false
      },
      set () {}
    }
  },

  filters: {
    ellipsis(value) {
      if (!value) return;
      const date = new Date(value)
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return (
              year + '/' + month + '/' + day
      )
    }
  },

  methods: {
    showWaterMarkStatus() {
      // console.log(`---- showWaterMarkStatus ${this.config.SHOW_CS_FILE_WATERMARK_STATUS}`)
      return this.config.SHOW_CS_FILE_WATERMARK_STATUS === 'true'
    },
    change(value,index){
      this.currentPage=1;
      this.handleSearchList();
    },

    /**
     * 页面变更
     */
    onPageSizeChange(e){
      this.pageSize=e;
      this.currentPage=1;
      this.handleSearchList();
    },

    /**
     * 方法明细（标号+方法description）：
     * -1:选择全部设备
     * 0.（新增文件）属性展示监听控件
     * 1.获取筛选条件列表（获取分类、属性、属性值数据结构）
     * 2.文件列表搜索相关方法
     * 3.浏览文件相关方法
     * 4.编辑文件
     * 5.删除/恢复文件
     * 6.获取设备系列机型列表
     * 7.获取文件资料类型列表
     * 8.打开添加文件对话框（先获取资料类型、设备机型）
     * 9.添加文件相关方法
     * 10.权限展示方法getAccessMark
     * 11.资料名称列表搜索处理
     * 12.文件置顶
     * 13.新增文档过期时间参数配置函数
     */


    selectAll (checked) {
      if (checked) {
        this.addFileForm.seriesValue = this.seriesData.map(d => d.key)
      } else {
        this.addFileForm.seriesValue = []
      }
    },

    onLoadImg: function (e) {
      const imgURL=this.fileUrl;
      const res = new Image();
      res.src = imgURL;
      if(res.naturalHeight/res.naturalWidth>1){
        this.boxHeight=650 +'px';
        this.boxWidth=Math.floor(650*res.naturalWidth/res.naturalHeight) +'px';
      }
      else if(res.naturalHeight/res.naturalWidth===1){
        if(res.naturalHeight>650){
          this.boxHeight=650 +'px';
          this.boxWidth=650 +'px';
        }
        else{
          this.boxWidth=res.naturalWidth + 'px';
          this.boxHeight=res.naturalHeight +'px';
        }
      }
      else if(res.naturalWidth/res.naturalHeight>1){
        this.boxWidth=900 +'px';
        this.boxHeight=Math.floor(900*res.naturalHeight/res.naturalWidth) +'px';
      }
      this.$forceUpdate();
    },

    onTypeChange(e){
      if(e===0){
        this.showSpecificProp=true;
        this.showExpireTimeInput=false;
        this.addFileForm.accessLimit='';
      }
      else if(e===1){
        //如果是学习资源，那么无需传值部分参数
        this.showSpecificProp=false;
        this.showExpireTimeInput=true;
        this.addFileForm.accessLimit=0;
        this.csFileParam={};
        this.addFileForm.seriesValue=[];
        this.addFileForm.fileCategory=[];
      }
    },

    showDataType(dataType) {
      if (dataType !== null && this.options !== []) {
        for (const temp of this.options) {
          if ((temp.fieldValue-0) === dataType) {
            return temp.showName;
          }
        }
      }
      return "-";
    },

    showSpecificValueByFieldName(dataType, fieldName, fieldValue) {
      if (dataType !== null && fieldName !== null && fieldName !== "") {
        for (const condition of this.options) {
          if (dataType === (condition.fieldValue-0)) {
            const property = condition.childConditionList;
            if (property !== null && property !== []) {
              for (const prop of property) {
                if (prop.fieldName === fieldName) {
                  const specificValueList = prop.childConditionList;
                  if (specificValueList !== null && specificValueList !== []) {
                    for (const value of specificValueList) {
                      console.log(fieldValue);
                      console.log(value.fieldName);
                      console.log(value.fieldValue);
                      if (value.fieldValue !== null && fieldValue === (value.fieldValue-0)) {
                        return value.showName;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      return "无";
    },

    /**
     * 0.（新增文件）属性展示监听控件 特殊字段隐藏与展示
     */
    onDataTypeChange(e){
      console.log(e);
      this.csFileParam={
          areaType:      null,      // 作用领域
          dataType: e,
          controlPanel:  null,      // 控制面板
          parts:         null,      // 部件
          power:         null,      // 功率值
          speedGovernor: null,      // 限速器
      };
      this.addFileForm.seriesValue=[];
      this.isShowAreaType=false;
      this.isShowControlPanel=false;
      this.isShowPower=false;
      this.isShowSpeedGovernor=false;
      this.isShowParts=false;
      this.getSeriesList(e);
      if(null!==e && this.options!==[]){
        for(const category of this.options){
          if (category.fieldValue === e) {
            const childConditionList = category.childConditionList;
            console.log(childConditionList);
            if (childConditionList !== []){
              for (const property of childConditionList){
                const value=[];
                if (property.childConditionList !== []) {
                  for (const tempValue of property.childConditionList) {
                    value.push({value: tempValue.fieldValue, label: tempValue.showName});
                  }
                }
                if(property.fieldName==="parts"){
                  this.isShowParts=true;
                  this.partOptions=value;
                  // this.nameParts=property.showName;
                }
                else if(property.fieldName==="controlPanel"){
                  this.isShowControlPanel=true;
                  this.controlPanelOptions=value;
                  // this.nameControlPanel=property.showName;
                }
                else if(property.fieldName==="power"){
                  this.isShowPower=true;
                  this.powerOptions=value;
                  // this.namePower=property.showName;
                }
                else if(property.fieldName==="speedGovernor"){
                  this.isShowSpeedGovernor=true;
                  this.speedGovernorOptions=value;
                  // this.nameSpeedGovernor=property.showName;
                }
                else if(property.fieldName==="areaType"){
                  this.isShowAreaType=true;
                  this.areaTypeOptions=value;
                  // this.nameAreaType=property.showName;
                }
                else if(property.fieldName==="csFileTypeID"){
                  this.fileCategoryOptions=value;
                }
              }
            }
          }

        }
      }
    },

    /**
     * @description: 1.获取筛选条件列表（获取分类、属性、属性值数据结构）
     * @param {*}
     * @return {*}
     */
    getConditionList() {
      let param={
        includeChild:1
      };
      getConditionList(param).then((res) => {
        this.options = res.data;
      });
    },

    /**
     * 筛选条件与资源类型是两个不同属性，筛选条件是根据资源类型生成，这里列出两者对应关系，方便使用
     * @param entity
     */
    getFileTypeDespWithCondition(entity){
      // 暂时没有反馈，先屏蔽，待有需求再放开
      // let item = this.fileCategoryData.find(element => element.csFileTypeID == entity.fieldValue);
      // if(isVaild(item)){
      //   return `${entity.showName} (${item.typeName})`
      // }
      return entity.showName;
    },

    /*************2.以下是文件列表搜索相关方法****************/

    /**
     * 顶部tab切换相应
     */
    handleClick() {
      if (this.activeName !== '-1') {      //-1用于筛选全部
        this.listQuery.keyword = "";
        this.showCategorySelect = true;
        for (const temp of this.options) {
          if (this.activeName === temp.fieldValue) {
            this.conditionOptions = temp.childConditionList;
            this.listQuery.category=temp;
          }
        }
      }
      else{
        this.showCategorySelect=false;
        this.listQuery.category={};
        this.conditionOptions=[];
      }
      //清空选项
      this.listQuery.condition = {};
      this.listQuery.conditionVal = {};
      this.arr=[];
      //变更属性下拉选项内容
      this.conditionValOptions = [];
      this.currentPage=1;
      //搜索
      this.handleSearchList();
    },

    // 分类改动
    onCategoryChange(e) {
      if(e!==null){
        this.showCategorySelect=true;
      }
      this.conditionOptions = e.childConditionList;
      //清空选项
      this.listQuery.condition={};
      this.listQuery.conditionVal={};
      //变更属性下拉选项内容
      this.conditionValOptions=[];
      //搜索
      this.handleSearchList();
    },

    // 筛选条件改动
    onConditionChange(e) {
      //清空选项
      this.listQuery.conditionVal={};
      //变更值下拉选项内容
      this.conditionValOptions = e.childConditionList;
    },

    onFieldValueChange(){
      //搜索
      this.handleSearchList();
    },
    handleFileType(){
      if(this.listQuery.type===0){
        this.showConditionTab=true;
        this.showSelect=true;
        this.showCategory=true;
        this.handleClick();
      }
      else if(this.listQuery.type===1){
        this.showConditionTab=false;
        this.conditionOptions=[];
        this.arr=[];
        this.listQuery.category= {};
        this.showSelect=false;
        this.showCategory=false;
        this.currentPage=1;
        this.handleSearchList();
      }
    },

    /**
     * @description: 筛选查询
     * @param {*}
     * @return {*}
     */
    handleSearchList() {
      this.loading = true;
      this.isSearched = true;
      const listQuery = this.listQuery;
      let conditionsList = [];
      // 分类作为筛选条件
      if (
        listQuery.category.fieldName &&
        listQuery.category.fieldOp &&
        listQuery.category.fieldValue
      ) {
        conditionsList.push({
          field: listQuery.category.fieldName,
          op: listQuery.category.fieldOp,
          value: listQuery.category.fieldValue,
        });
      }
      // 属性作为筛选条件
      if(this.arr!==[]){
        for(const temp of this.arr){
          if(temp === undefined || temp === null){
            continue;
          }
          if (temp!=="" && temp.fieldName!=="" && temp.fieldValue!==null &&temp.fieldValue!==""){
            conditionsList.push({
              field: temp.fieldName,
              op: temp.fieldOp,
              value: temp.fieldValue,
            });
          }
        }
      }

      // 初始化请求参数
      let params = {
        keyWord: listQuery.keyword || "",
        type:listQuery.type,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };
      if (conditionsList.length) {
        params.where = conditionsList
      }
      // 发起请求
      getFileByCondition(params).then((res) => {
        console.log(res);
        this.fileList = res.data.rows;
        this.totalCount = res.data.total;
        this.utils.stopLoading(this);
      });
    },
    /**
     * @description: 重置搜索表单
     * @return {*}
     */
    handleResetSearch() {
      this.activeName="-1";
      this.showCategorySelect=false;
      // 清空搜索框
      this.listQuery.keyword = "";
      this.listQuery.type=0;
      this.handleFileType();
      // 清空分类检索框
      this.listQuery.category = {};
      this.listQuery.condition={};
      this.listQuery.conditionVal={};
      this.getFileList();
      // 清空筛选条件框
      // this.$refs.conditionRef.clearCheckedNodes();
      //清空完重新搜索
    },

    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      if (!this.isSearched) {
        this.getFileList();
        this.getConditionList();
      } else {
        this.handleSearchList();
        this.getConditionList();
      }
    },
    /**
     * 搜索
     */
    search() {
      if (!this.searchValue) {
        this.$message({
          message: "The search input cannot be empty.",
          type: "warning",
        });
        return;
      }
      this.currentPage = 1;
      this.getFileList();
    },
    /**
     * 重置
     */
    reset() {
      this.searchValue = "";
      this.currentPage = 1;
      this.getFileList();
    },
    /**
     * 获取文件列表
     */
    getFileList() {
      let params = {
        UserDataType: 2,
        sortName: "",
        sortOrder: "",
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.searchValue,
        where: "",
      };
      this.loading = true;
      getFileList(params).then((res) => {
        this.fileList = res.data.rows;
        // vm.$set(this.fileList,res.data.rows);
        this.totalCount = res.data.total;
        this.utils.stopLoading(this);
      });
    },
    /*************以下是文件列表搜索相关方法****************/

    /***********3.以下是浏览文件相关方法**********/
    /**
     * 查看文件系列
     *
     * @param {object} row 选中对象
     */
    viewFileSeries(row) {
      this.seriesListDialog = true;
      this.seriesList = row.seriesList;
    },
    /**
     * 查看文件
     *
     * @param {object} row 选中对象
     */
    viewFile(row) {
      this.filePlayName=row.fileName+row.fileSuffix;
      let type = this.iconByType(row);
      this.fileUrl = this.config.RESOURCES+row.downUrl;

      if (type.indexOf("doc") !== -1 || type.indexOf("docx") !== -1 || type.indexOf("xls") !== -1 || type.indexOf("xlsx") !== -1) {
        this.showDoc = true;
      }
      else if (type.indexOf("pdf") !== -1) {
        this.showPdf = true;
      }
      else if (type.indexOf("jpg") !== -1 || type.indexOf("png") !== -1 || type.indexOf("jpeg") !== -1) {
        this.showImg=true;
      }
      else if (type.indexOf("avi") !== -1 || type.indexOf("mp4") !== -1 || type.indexOf("webm") !== -1 || type.indexOf("m4v") !== -1 || type.indexOf("rmvb") !== -1 || type.indexOf("mpg") !== -1 || type.indexOf("3gp") !== -1 || type.indexOf("swf") !== -1 || type.indexOf("mkv") !== -1) {
        this.showVideo = true;
      }
      else if (type.indexOf("mp3")!== -1){
        this.showMp3 = true;
      }
      else {
        this.$message("当前文件暂不支持预览")
      }
    },
    /**
     * 经过文件后缀返回文件的图标
     */
    iconByType(row) {
      return row.fileSuffix.substring(row.fileSuffix.lastIndexOf(".") + 1, row.fileSuffix.length)
    },
    closePreviewClick() {
      if (this.showDoc === true) {
        this.showDoc = false;
      } else if (this.showPdf === true) {
        this.showPdf = false;
      } else if (this.showVideo === true) {
        this.showVideo = false;
      } else if (this.showImg === true ){
        this.showImg = false;
      } else if (this.showMp3 === true){
        this.showMp3 = false;
      }
    },
    /***********以上是浏览文件相关方法**********/

    /**
     * 下载文件
     *
     * @param {object} row 选中对象
     */
    downloadFile(row) {
      FileSaver.saveAs(this.config.RESOURCES + row.downUrl, row.fileName);
    },

    /**
     * 打开编辑文件对话框
     *
     * @param {object} row 选中对象
     */
    openEditFileDialog(row) {
      // 初始化
      this.editFileDialog = true;
      this.showProgress=false;//进度条的显示
      this.progress= 0; //进度条数据

      this.addFileForm.type=row.type; //标识
      this.addFileForm.submitType=1;
      this.addFileForm.csFileID=row.csFileID;
      this.addFileForm.url=row.downUrl;
      this.addFileForm.size=row.fileSize;
      this.addFileForm.suffix=row.fileSuffix;
      this.addFileForm.fileName=row.fileName;
      this.addFileForm.showName=row.fileShowName;
      this.addFileForm.desc=row.fileDesc;
      this.addFileForm.accessLimit=row.accessLimit;
      this.addFileForm.waterMarkStatus = row.waterMarkStatus

      if (row.type === 1) {
        this.showSpecificProp=false;
        this.showExpireTimeInput=true;
        this.csFileParam={};
      }
      else{
        this.showSpecificProp=true;
        this.showExpireTimeInput=false;
        this.csFileParam.dataType=row.csFileParams.dataType.toString();
        this.onDataTypeChange(this.csFileParam.dataType);
        this.csFileParam.areaType=row.csFileParams.areaType.toString();
        this.csFileParam.controlPanel=row.csFileParams.controlPanel.toString();
        this.csFileParam.parts=row.csFileParams.parts.toString();
        this.csFileParam.power=row.csFileParams.power.toString();
        this.csFileParam.speedGovernor=row.csFileParams.speedGovernor.toString();

        if (row.seriesList !== null) {
          let seriesList = [];
          for (var item of row.seriesList) {
            seriesList.push(item.machineSeriesID);
          }
          this.addFileForm.seriesValue = seriesList;
        }
        this.getSeriesList(this.csFileParam.dataType);
        if (row.typeList !== null) {
          let csFileTypeID = [];
          for (var item of row.typeList) {
            csFileTypeID.push(item.csFileTypeID.toString());
          }
          console.log("资料类型为："+csFileTypeID);
          this.addFileForm.fileCategory=csFileTypeID;
        }
        this.getAccessMark();//获取权限信息
      }

    },
    /**
     * 4.编辑文件
     */
    editFile() {
      // 表单验证
      if (!this.addFileForm.showName) {
        this.$notify({
          title: '温馨提示',
          message: '文件名不能为空',
          type: 'warning'
        });
        return;
      }
      if(this.addFileForm.accessLimit!==0 && !this.addFileForm.accessLimit){
        this.$notify({
          title: '温馨提示',
          message: '\"文档访问限制\"不能为空',
          type: 'warning'
        });
        return;
      }
      console.log("xiix");
      console.log(this.addFileForm.fileCategory);
      if ((!this.addFileForm.fileCategory.length ||this.addFileForm.fileCategory[0] === "") && 0 === this.addFileForm.type) {
        this.$notify({
          title: '温馨提示',
          message: '请选择\'资料类型\'',
          type: 'warning'
        });
        return;
      }
      console.log("haha");
      console.log(this.csFileParam.dataType);
      if((this.csFileParam.dataType===null||this.csFileParam.dataType===undefined || this.csFileParam.dataType==='') && 0 === this.addFileForm.type){
        this.$notify({
          title: '温馨提示',
          message: '请选择\'所属分类\'',
          type: 'warning'
        });
        return;
      }
      if(this.uploadFileList.length===0){
        console.log("不带文件更新");
        this.updateFile();
      }else{
        this.$refs.upload.submit();
        console.log("带文件更新");
      }
    },

    updateFile(){
      const data = {
        // type:0, //待定
        csFileID:this.addFileForm.csFileID,              //唯一标识
        downUrl: this.addFileForm.url,                   // 下载地址
        fileDesc: this.addFileForm.desc,                 // 文件描述
        fileName: this.addFileForm.fileName,             // 文件路径名
        fileShowName: this.addFileForm.showName,         // 外文名称
        fileSize: this.addFileForm.size,                 // 大小
        fileSuffix: this.addFileForm.suffix,             // 尾缀
        userDataType: this.addFileForm.userDataType,     // 文件类别：产品资料或学习资源
        seriesIDList: this.addFileForm.seriesValue,      // 所属系列
        fileTypeIDList: this.addFileForm.fileCategory,   // 资源类型
        accessLimit:this.addFileForm.accessLimit,        // 文档访问限制
        waterMarkStatus:this.addFileForm.waterMarkStatus
      };
      // 针对产品资料（this.addFileForm.type === 0）需要对特殊属性进行更新，学习资源则不用
      if (this.addFileForm.type !== null && this.addFileForm.type === 0 ) {
        data.csFileParam={
          dataType:this.csFileParam.dataType,
          power:this.csFileParam.power,
        };
        if (this.csFileParam.areaType !== null && this.csFileParam.areaType !== "") {
          data.csFileParam.areaType = this.csFileParam.areaType - 0;
        }
        if (this.csFileParam.parts !== null && this.csFileParam.parts !== "") {
          data.csFileParam.parts = this.csFileParam.parts - 0;
        }
        if (this.csFileParam.speedGovernor !== null && this.csFileParam.speedGovernor !== "") {
          data.csFileParam.speedGovernor = this.csFileParam.speedGovernor - 0;
        }
        if (this.csFileParam.controlPanel !== null && this.csFileParam.controlPanel !== "") {
          data.csFileParam.controlPanel = this.csFileParam.controlPanel - 0;
        }
      }
      console.log("准备更新啦：")
      console.log(data);
      editFile(data).then(() => {
        this.$notify({
          title: '操作成功',
          message: '更新成功，请在列表查阅此文件信息',
          type: 'success'
        });
      });
      this.editFileDialog = false;
      this.addFileForm.submitType=0;
      // this.refreshParams();
      // this.handleResetSearch();
      this.timeout = setTimeout(() => {
        this.handleSearchList();
      }, 2000 * Math.random());

    },

    /**
     * 5.删除/恢复文件
     *
     * @param {object} row 选中对象
     */
    deleteFile(row) {
      let params = {
        csFileId: row.csFileID,
      };
      let tips;
      if (row.isDeleted) {
        tips = "您要恢复此文件吗？";
      } else {
        tips = "您要删除此文件吗？";
      }
      this.$confirm(tips, this.$t("tips"), {
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no"),
        type: "warning",
      })
        .then(() => {
          deleteFile(params).then(() => {
            this.$notify({
              title: '文件删除成功',
              type: 'success'
            });
            this.timeout = setTimeout(() => {
              this.handleSearchList();
            }, 2000 * Math.random());
          });
        })
        .catch(() => {
          this.$message("取消操作");
        });
    },

     /***********6.以下获取设备系列机型方法****************/
    /**
     * 获取设备系列机型列表
     */
    getSeriesList(e) {
      return new Promise((resolve, reject) => {
        let where="";
        if(e!==null  && e!==""){
          where = [
                    {
                      "field": "csFileConditionID",
                      "value": "" + e,
                      "op": "equal",
                    }
                  ];
        }
        const param = {
          sortName: "",
          sortOrder: "asc",
          pageNumber: 1,
          // 后台不允许返回所有数据，临时设置pageSize = 99
          pageSize: 999,
          keyword: "",
          where: where
        };
        getMachineSeriesList(param).then((res) => {
          this.seriesData = [];
          res.data.rows.forEach((i) => {
            let obj = {
              key: i.machineSeriesID,
              label: i.model + " " + i.version,
            };
            this.seriesData.push(obj);
          });
          resolve("getSeriesList done");
        });
      });
    },

    //重置options(select自动补全相关)
    remoteMethod(queryString, lists) {
      if(queryString !=="" && lists !== null){
        this.seriesData = [];
        console.log(lists);
        for(var item of lists){
          console.log(item);
          if (item.label.lastIndexOf(queryString)!==-1){
            this.seriesData.push(item);
          }
        }
      }
      else{
        this.getSeriesList();
      }
    },
    /***********以上获取设备系列机型方法****************/


    /**
     * 7.获取文件资料类型列表
     */
    getFileCategoryList() {
      return new Promise((resolve, reject) => {
        let params = {
          sortName: "",
          sortOrder: "asc",
          pageNumber: 1,
          pageSize: 99,
          keyword: "",
          where: "",
        };
        getFileCategoryList(params).then((res) => {
          this.fileCategoryData = [];
          if (res.data!==null&& res.data.rows!==null&& res.data.rows !== []) {
            for (const temp of res.data.rows) {
              if (temp.deleteTime === null) {
                this.fileCategoryData.push(temp);
              }
            }
          }
          resolve("getFileCategoryList done");
        });
      });
    },

    /**
     * 8.打开添加文件对话框（先获取资料类型、设备机型）
     */
    openAddFileDialog() {
      // 初始化
      this.addFileForm = {
        submitType:0,
        userDataType: 2,
        name: "",
        desc: "",
        seriesValue: [],
        fileCategory: [],
        waterMarkStatus: 0
      };
      this.csFileParam={
        areaType:      null,
        controlPanel:  null,
        dataType:      null,
        parts:         null,
        power:         null,
        speedGovernor: null,
      };
      this.showProgress=false;//进度条的显示
      this.progress= 0; //进度条数据
      this.uploadFileList = [];  //初始化上传文件列表
      this.showSpecificProp=true;
      this.showExpireTimeInput=false;
      Promise.all([this.getFileCategoryList(), this.getSeriesList(null)])
        .then((res) => {
          this.addFileDialog = true;
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**********9.以下是添加文件相关方法************/
    /**
     * 添加文件
     */
    addFile() {
      const data = {
        type: this.addFileForm.type,         // 文件类型：产品资料或学习资源
        downUrl: this.addFileForm.url,       // 下载地址
        fileDesc: this.addFileForm.desc,     // 文件描述
        fileName: this.addFileForm.fileName, // 文件路径名
        fileSize: this.addFileForm.size,     // 文件大小
        fileSuffix: this.addFileForm.suffix, // 后缀名
        fileShowName: this.addFileForm.showName, // 文件展示名
        userDataType: this.addFileForm.userDataType, // 医用/射线
        seriesIDList: this.addFileForm.seriesValue, // 所属系列
        fileTypeIDList: this.addFileForm.fileCategory, // 资料类型
        accessLimit:this.addFileForm.accessLimit, //文档访问限制
        csFileParam: this.csFileParam, // 文件详细类型
        waterMarkStatus:this.addFileForm.waterMarkStatus
      };
      console.log("准备新增文件"+data);
      addFile(data).then(() => {
        this.$notify({
          title: '操作成功',
          message: '文件新增成功，请在列表查阅此文件信息',
          type: 'success'
        });
        this.addFileDialog = false;
        this.refreshParams();
        this.timeout = setTimeout(() => {
          this.handleSearchList();
        }, 2000 * Math.random());
      });
    },

    /**
     * 清空入参和显示标志
     */
    refreshParams(){
      this.addFileForm.csFileID="";
      this.addFileForm.url="";
      this.addFileForm.fileName="";
      this.addFileForm.showName="";
      this.addFileForm.accessLimit='';
      this.addFileForm.desc="";
      this.addFileForm.seriesValue=[];
      this.addFileForm.fileCategory=[];
      this.addFileForm.size=0;
      this.addFileForm.suffix="";
      this.addFileForm.type=null;
      this.csFileParam.areaType=null;
      this.csFileParam.controlPanel=null;
      this.csFileParam.dataType=null;
      this.csFileParam.parts=null;
      this.csFileParam.power=null;
      this.csFileParam.speedGovernor=null;
      this.isShowAreaType=false;
      this.isShowControlPanel=false;
      this.isShowPower=false;
      this.isShowSpeedGovernor=false;
      this.isShowParts=false;
      this.isShowMachineSeries=true;
      this.accessMark="";
      this.uploadFileList=[];
    },

    /**
     * 获取OSS上传信息
     *
     * @param {object} file 文件对象
     */
    getOSSUploadInfo(file) {
      const params = {
        DataType: "24",
        ID: "0",
      };

      getOSSUploadInfo(params).then((res) => {
        this.ossInfo = res.resultData.AssumeRoleToken;
        this.ossPath = res.resultData.PicSavePath;
        this.uploadFile(file);
      });
    },

    /**
     * 上传服务器
     *
     * @param {object} file 文件对象
     */
    uploadFile(file) {
      const uploadFile = file.file; // 获取上传的file对象
      const uploadFileSize = uploadFile.size / 1024 / 1024; // 获取上传文件的大小，单位 MB
        console.log("分片上传");
        this.multipartUpload(file);
    },
    /**
     * 普通上传
     */
    async commonUpload(file) {
      let OSS = require("ali-oss");
      // 实例化OSS Client。
      let client = new OSS({
        region: this.config.OSS_END_POINT,
        accessKeyId: this.ossInfo.AccessKeyId,
        accessKeySecret: this.ossInfo.AccessKeySecret,
        stsToken: this.ossInfo.SecurityToken,
        bucket: this.config.OSSBUCKET,
        timeout: 600000,
      });

      let timestamp = new Date().valueOf();
      const fileName = file.file.uid + "_" + timestamp;
      const options = {
        // 获取分片上传进度、断点和返回值。
        progress: function(p) {
          //p进度条的值
          console.log(p);
          this.showProgress = true;
          this.progress = Math.floor(p * 100);
        }
      };
      client
        .put(this.ossPath + fileName, file.file, options)
        .then((res) => {
          console.log("普通上传", res);
          this.uploadLoading = false;
          if (res.url) {
            this.addFileForm.fileName = fileName;
            this.addFileForm.url = "/" + this.ossPath + fileName;
            console.log(this.addFileForm.submitType);
            if(this.addFileForm.submitType!==null){
              if(this.addFileForm.submitType===0){
                console.log("准备新增")
                this.addFile();
              }
              else if(this.addFileForm.submitType===1){
                console.log("准备更新");
                this.updateFile();
              }
            }
          } else {
            this.$message.error("Upload failed");
          }
        })
        .catch((err) => {
          this.uploadLoading = false;
          console.log("Upload OSS Error:", err);
        });
    },
    /**
     * 分片上传
     */
    async multipartUpload(file) {
      let OSS = require("ali-oss");
      // 实例化OSS Client。
      let client = new OSS({
        region: this.config.OSS_END_POINT,
        accessKeyId: this.ossInfo.AccessKeyId,
        accessKeySecret: this.ossInfo.AccessKeySecret,
        stsToken: this.ossInfo.SecurityToken,
        bucket: this.config.OSSBUCKET,
        timeout: 600000,
      });

      const options = {
        // 获取分片上传进度、断点和返回值。
        progress:(p) =>{
          //p进度条的值
          console.log("haha");
          console.log(p);
          this.showProgress = true;
          this.progress = Math.floor(p * 100);
        },
        // 设置并发上传的分片数量。
        parallel: 4,
        // 设置分片大小。默认值为1 MB，最小值为100 KB。
        partSize: 1024 * 1024,
      };

      let timestamp = new Date().valueOf();
      const fileName = file.file.uid + "_" + timestamp;
      client
        .multipartUpload(this.ossPath + fileName, file.file, options)
        .then((res) => {
          this.uploadLoading = false;
          console.log("res", res);
          if (res.res.requestUrls) {
            this.addFileForm.fileName = fileName;
            this.addFileForm.url = "/" + this.ossPath + fileName;
            console.log(this.addFileForm.submitType);
            if(this.addFileForm.submitType!==null){
              if(this.addFileForm.submitType===0){
                this.addFile();
              }
              else if(this.addFileForm.submitType===1){
                this.updateFile();
                this.addFileForm.submitType=0;
              }
            }
          } else {
            this.$message.error("Upload failed");
          }
        })
        .catch((err) => {
          this.uploadLoading = false;
          console.log("Upload OSS Error:", err);
        });
    },

    /**
     * 提交文件上传信息
     */
    submitUpload() {
      // 表单验证
      if (!this.addFileForm.showName) {
        this.$notify({
          title: '温馨提示',
          message: '文件名不能为空',
          type: 'warning'
        });
        return;
      }
      console.log(this.uploadFileList);
      if(this.addFileForm.accessLimit!==0 &&!this.addFileForm.accessLimit){
        this.$notify({
          title: '温馨提示',
          message: '请补充\"文档访问限制\"',
          type: 'warning'
        });
        return;
      }
      if (!this.uploadFileList.length) {
        this.$notify({
          title: '温馨提示',
          message: '请上传一个文件',
          type: 'warning'
        });
        return;
      }
      if(null === this.addFileForm.type|| undefined === this.addFileForm.type){
        this.$notify({
          title: '温馨提示',
          message: '请选择\'文件类型\'',
          type: 'warning'
        });
        return;
      }
      if(this.addFileForm.fileCategory.length===0 && 0 === this.addFileForm.type){
        this.$notify({
          title: '温馨提示',
          message: '请选择\'资源类型\'',
          type: 'warning'
        });
        return;
      }
      if(this.csFileParam.dataType===null && 0 === this.addFileForm.type){
        this.$notify({
          title: '温馨提示',
          message: '请选择\'所属分类\'',
          type: 'warning'
        });
        return;
      }
      console.log("!",this.$refs.upload.submit);
      //debugger;
      this.$refs.upload.submit();
      //debugger;
    },
    /**
     * 监听上传文件，更新数组
     *
     * @param {object} file 文件对象
     * @param {array} fileList 文件对象列表
     */
    onChange(file, fileList) {
      this.uploadFileList = fileList;
    },
    /**
     * 监听移除文件，更新数组
     *
     * @param {object} file 文件对象
     * @param {array} fileList 文件对象列表
     */
    onRemove(file, fileList) {
      this.uploadFileList = fileList;
    },
    /**
     * 上传数量限制提示
     */
    handleExceed() {
      this.$message({
        message: "一次只能上传一个文件",
        type: "warning",
      });
    },
    /**
     * 上传限制校验
     *
     * @param {object} file 文件对象
     */
    beforeUpload(file) {
      // 文件类型限制
      let exname = file.name.substring(file.name.lastIndexOf(".") + 1);
      const fileTypes = ["pdf","mp4","mp3","jpg","png"];
      if (fileTypes.indexOf(exname) < 0) {
        this.$message({
          message: "上传文件只能是 PDF / MP4 / MP3 / JPG / PNG 格式",
          type: "warning",
        });
        this.uploadLoading = false;
        return false;
      }

      // 文件大小限制
      const isOverSize = file.size / 1024 / 1024 > 2048;
      if (isOverSize) {
        this.$message({
          message: "文件大小不能超过 2GB",
          type: "warning",
        });
        this.uploadLoading = false;
        return false;
      }

      this.addFileForm.suffix = "." + exname;
      this.addFileForm.size = Math.round(file.size / 1024);
    },

    cancelUpdate(){
      this.editFileDialog = false;
      this.refreshParams();
    },

    cancelUpload(){
      this.refreshParams();
      this.addFileDialog = false;
    },

    handleAddFileDialogClose(){
      this.cancelUpload();
    },

    handleEditFileDialogClose(){
      this.cancelUpdate();
    },

    /**********以上是添加文件相关方法************/

    /**
     * 10.权限信息展示方法。根据资料类型 附带的角色权限数据，生成对应权限说明
     */
    getAccessMark() {
      const item = this.fileCategoryData.find(item1 => item1.csFileTypeID.toString() === this.addFileForm.fileCategory[0].toString());
      if (item !== null) {
        this.accessMark = "";
        console.log(item);
        for (var i in item.roleList) {
          var permission = "";
          if (1 === item.roleList[i].permissionType) {
            permission = ": 读"
          } else if (2 === item.roleList[i].permissionType) {
            permission = ": 读/下载"
          } else {
            permission = ": 无"
          }
          this.accessMark += item.roleList[i].roleName + permission + "; ";
        }
      }
    },


    /*************11.资料名称列表搜索*****************************/
    /**
     * 获取产品资料文档信息，提取资料名称
     */
    getCSDocumentList(){
      return new Promise((resolve ,reject)=>{
        const param = {
          sortName: "",
          pageNumber: "1",
          pageSize: "30",
          keyword: "",
          where: "",
        };
        getAllCSDocumentList(param).then((res) =>{
          this.nameSearchFinalList=[];
          res.data.rows.forEach((i) => {
            let obj = {
              value: i.fileShowName,
            };
            this.nameSearchFinalList.push(obj);
          });
        });
      });
    },

    /**
     * 文件名称搜索匹配过滤得到名称列表
     */
    querySearchAsync(queryString, cb) {
      var restaurants = this.nameSearchFinalList;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      cb(results);

    },

    /**
     * 文件名称匹配判断逻辑
     */
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().lastIndexOf(queryString.toLowerCase()) >= 0);
      };
    },

    /************以上是资料名称列表搜索*****************************/

    /***
     * 12.文件置顶
     */
    onTopStatusChange(csFileID,e){
      let params={
        csFileID:csFileID,
        topStatus:e?1:0,
      };
      topStatusFile(params).then((res)=>{
        console.log(res);
      });
    },

    /*********************13.以下是新增/编辑文档过期时间相关函数*****************************/

    selectChange(val) {
      this.addFileForm.accessLimit = val;
      this.$forceUpdate();
    },
    /*********************13.以上是新增/编辑文档过期时间相关函数*****************************/

  },

};
</script>

<style lang="scss" scoped>
.demo-table-expand {
  font-size: 0;
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
    ::v-deep .el-form-item__label {
      width: 120px;
      color: #99a9bf;
    }
  }
}

.el-dropdown-link {
  cursor: pointer;
}

.el-icon-s-operation {
  font-size: 24px;
}

.el-select__tags-text {
  display: inline-block;
  max-width: 200px;
  @media (max-width: 1400px) {
    max-width: 42px;
  }
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.el-select .el-tag__close.el-icon-close {
  top: -7px;
  right: -4px;
}

</style>
